import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=311fb841&scoped=true&"
import script from "./TabsView.vue?vue&type=script&lang=js&"
export * from "./TabsView.vue?vue&type=script&lang=js&"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=311fb841&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311fb841",
  null
  
)

export default component.exports